import { Injectable } from '@angular/core';
import { concat, Observable } from 'rxjs';
import { first, tap } from 'rxjs/operators';

import { TraderApiRepository } from '../repositories/trader-api.repository';
import { TraderCacheRepository } from '../repositories/trader-cache.repository';
import { TraderInterface } from '../data';
import { Transaction } from '../transaction/transaction';

@Injectable()
export class TraderProvider {
    constructor(private traderApiRepository: TraderApiRepository, private traderCacheRepository: TraderCacheRepository) {}

    find(): Observable<Transaction<TraderInterface[]>> {
        const cacheId = this.traderCacheRepository.getKey();

        return concat(
            this.traderCacheRepository.load(cacheId),
            this.traderApiRepository.load().pipe(
                tap((transaction) => {
                    if (transaction.isSuccess) {
                        this.traderCacheRepository
                            .save(
                                cacheId,
                                transaction.data.sort((a, b) => (a.name > b.name ? 1 : b.name > a.name ? -1 : 0))
                            )
                            .subscribe();
                    }
                })
            )
        ).pipe(first());
    }

    findExternal(): Observable<Transaction<TraderInterface[]>> {
        const cacheId = this.traderCacheRepository.getKey(true);

        return concat(
            this.traderCacheRepository.load(cacheId),
            this.traderApiRepository.loadExternal().pipe(
                tap((transaction) => {
                    if (transaction.isSuccess) {
                        this.traderCacheRepository
                            .save(
                                cacheId,
                                transaction.data.sort((a, b) => (a.name > b.name ? 1 : b.name > a.name ? -1 : 0))
                            )
                            .subscribe();
                    }
                })
            )
        ).pipe(first());
    }
}
